import { ContainerModule } from 'inversify';
import { PlayerModuleSymbol } from '../api';
import { notificationServiceModule } from './service/di'
import { notificationStateModule } from './store/di'
import { NotificationPlayerModule } from './notification-player-module'

const notificationModule = new ContainerModule((bind) => {
  bind(PlayerModuleSymbol).to(NotificationPlayerModule)
});

export const notificationModules = [
  notificationModule,
  notificationServiceModule,
  notificationStateModule
]
